import { ContentChunkFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import OptimizedImage from '@/ui/components/shared/OptimizedImage';
import { ParagraphCollectionRenderer } from '@/ui/components/tileRenderers/ParagraphCollectionRenderer/ParagraphCollectionRenderer';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import React from 'react';

export default function HelpScreen({ chunk }: { chunk: ContentChunkFragment }) {
  const helpScreenChunk = chunk.chunks?.[0];
  const title = extractComponentFromChunk(helpScreenChunk, 'title', 'SingleLineContent')?.text;
  const description = extractComponentFromChunk(
    helpScreenChunk,
    'description',
    'ParagraphCollectionContent',
  );
  return (
    <div>
      <h2 className="mb-2 text-2xl font-bold">{title}</h2>
      {description?.paragraphs?.map((paragraph, index) => (
        <div key={`description-paragraph-${index}`} className="my-1">
          <RichTextRenderer blocks={paragraph.body} />

          {paragraph?.images?.map((image) => (
            <OptimizedImage
              key={image.url}
              image={image}
              width={1000}
              height={1000}
              sizes="(max-width: 768px) 100vw, 768px"
              className=" my-4 max-h-37"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
